// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"344":"backdoor","525":"articles"}[chunkId] + "." + {"344":"4bac124f","525":"bed9a607"}[chunkId] + ".js";
};